import { useCallback, useState } from 'react';
import {
  useHeaCreateGroupModuleMutation,
  useHeaUpdateGroupModuleMutation,
  useHeaDeleteGroupModuleMutation,
  useHeaGetModuleAllGroupsLazyQuery,
} from '@api/graphql-codegen';
import { ExtendedContent, DefaultModuleEnum } from '@types';
import { logger } from '../../../../../utils/logger';

interface useHeaGroupModuleCRUDProps {
  currentTabContent?: ExtendedContent;
  heaGroups: ExtendedContent[];
  activeTab: string;
  onChangeGroupTabs: (v: ExtendedContent[]) => void;
  onChangeTab: (key: string) => void;
  clearFile: () => void;
};

export const useHeaGroupModuleCRUD = ({ heaGroups, onChangeGroupTabs, currentTabContent, activeTab, onChangeTab, clearFile }: useHeaGroupModuleCRUDProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [createHeaGroupModule, { loading: isCreatinggHeaGroupModule }] = useHeaCreateGroupModuleMutation();

  const [updateHeaGroupModule, { loading: isUpdatingHeaGroupModule }] = useHeaUpdateGroupModuleMutation({
    update(__cache, res) {
      setLoading(false);
      const updatedGroupContent = res.data?.heaUpdateGroupModule;
      if (updatedGroupContent) {
        let updatingGroups: any[] = [...heaGroups];
        const index = updatingGroups.findIndex(u => u.groupId === updatedGroupContent?.groupId);
        if (index > -1) {
          updatingGroups[index] = {...updatingGroups[index], data: updatedGroupContent.data, formData: updatedGroupContent.formData, meta: updatedGroupContent.meta};
        }
        onChangeGroupTabs(updatingGroups);
        clearFile();
      }
    },
    onError(e) {
      logger.debug(`[e]`, e);
      setLoading(false);
    },
  });

  const [deleteHeaGroupModule, { loading: deletingHomeEdGroupModuleData }] = useHeaDeleteGroupModuleMutation({
    update(_, res) {
      setLoading(false);
      if (res.data?.heaDeleteGroupModule) {
        const defaultContent = heaGroups[0];
        let updatingGroups: any[] = heaGroups.slice(1);
        const index = updatingGroups.findIndex(a => a.groupName === activeTab);
        if (index > -1) {
          updatingGroups.splice(index, 1);
          onChangeGroupTabs([defaultContent, ...updatingGroups]);
        }
        onChangeTab(DefaultModuleEnum.HomeEd);
      }
    },
    onError(e) {
      setLoading(false);
      logger.info('e--', e);
    },
  });
  const [getAllHeaGroupModules, { loading: loadingHeaModuleGroups }] = useHeaGetModuleAllGroupsLazyQuery({ fetchPolicy: 'network-only' });

  const handleRemoveGroup = useCallback(() => {
    if (window.confirm(`Are you sure you want to remove ${currentTabContent?.groupName} group in the HomeEd Module?`)) {
      setLoading(true);
      const id = currentTabContent?.id || currentTabContent?.contentId
      if (id) {
        deleteHeaGroupModule({
          variables: {
            input: {
              moduleId: id,
              groupId: currentTabContent?.groupId
            }
          }
        })
      } else {
        setLoading(false);
      }
    }
  }, [currentTabContent, deleteHeaGroupModule]);

  return {
    createHeaGroupModule,
    updateHeaGroupModule,
    deleteHeaGroupModule,
    getAllHeaGroupModules,
    loading,
    isGroupsLoading: isCreatinggHeaGroupModule || isUpdatingHeaGroupModule || loadingHeaModuleGroups,
    isGroupRemoving: deletingHomeEdGroupModuleData,
    handleRemoveGroup
  }
};
